export default "__VITE_ASSET__LZbBptyP__"